// src/components/seo/seoManager.js
import { SEOData } from "./seoData";

export const SEOManager = {
  setMeta: ({ title, description, keywords, author, canonicalUrl }) => {
    document.title = title || SEOData.siteTitle;
    SEOManager._setOrUpdateMeta("description", description || SEOData.siteDescription);
    SEOManager._setOrUpdateMeta("keywords", keywords || "agroturism, Maramures, rezervari, camere");
    SEOManager._setOrUpdateMeta("author", author || SEOData.siteAuthor);
    SEOManager._setOrUpdateMeta("robots", "index, follow");
    SEOManager._setOrUpdateMeta("viewport", "width=device-width, initial-scale=1.0");
    SEOManager._setOrUpdateLink("canonical", canonicalUrl || SEOData.siteUrl);
  },

  setOpenGraph: ({ title, description, image, url, updatedTime }) => {
    SEOManager._setOrUpdateMeta("og:title", title, true);
    SEOManager._setOrUpdateMeta("og:description", description, true);
    SEOManager._setOrUpdateMeta("og:image", image, true);
    SEOManager._setOrUpdateMeta("og:url", url, true);
    SEOManager._setOrUpdateMeta("og:type", "website", true);
    SEOManager._setOrUpdateMeta("og:site_name", SEOData.siteTitle, true);
    if (updatedTime) SEOManager._setOrUpdateMeta("og:updated_time", updatedTime, true);
  },

  setTwitterCard: ({ title, description, image, cardType, siteHandle, creatorHandle }) => {
    SEOManager._setOrUpdateMeta("twitter:card", cardType || "summary_large_image");
    SEOManager._setOrUpdateMeta("twitter:title", title);
    SEOManager._setOrUpdateMeta("twitter:description", description);
    SEOManager._setOrUpdateMeta("twitter:image", image);
    SEOManager._setOrUpdateMeta("twitter:site", siteHandle || "@cuvia");
    SEOManager._setOrUpdateMeta("twitter:creator", creatorHandle || "@cuvia");
  },

  setStructuredData: (jsonLD) => {
    SEOManager._setOrUpdateScript("application/ld+json", JSON.stringify(jsonLD));
  },

  _setOrUpdateMeta: (name, content, property = false) => {
    if (!content) return;
    let meta = document.head.querySelector(
      property ? `meta[property="${name}"]` : `meta[name="${name}"]`
    );
    if (!meta) {
      meta = document.createElement("meta");
      if (property) meta.setAttribute("property", name);
      else meta.setAttribute("name", name);
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", content);
  },

  _setOrUpdateScript: (type, content) => {
    let script = document.head.querySelector(`script[type="${type}"]`);
    if (!script) {
      script = document.createElement("script");
      script.type = type;
      document.head.appendChild(script);
    }
    script.innerHTML = content;
  },

  _setOrUpdateLink: (rel, href) => {
    let link = document.head.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
  },
};
